import { collection, getDocs, query, orderBy, limit, where } from 'firebase/firestore';
import { db } from '../database/firebase';
import { apiGet, useApiData } from './apiClient';

export const getStocks = async (options = {}) => {
  try {
    const { eventID, limitCount = 100, orderByField = 'createdate', orderDirection = 'asc' } = options;

    if (useApiData) {
      const qs = new URLSearchParams();
      qs.set('perPage', String(limitCount));
      qs.set('sort', orderByField);
      qs.set('order', orderDirection);
      if (eventID) qs.set('event', eventID);
      const res = await apiGet(`stocks?${qs.toString()}`);
      return res?.data ?? [];
    }

    const collectionRef = collection(db, 'stocks');
    let q = null;
    
    if (eventID) {
      q = query(
        collectionRef, 
        orderBy(orderByField, orderDirection), 
        where('event', '==', eventID)
      );
    } else {
      q = query(
        collectionRef, 
        orderBy(orderByField, orderDirection), 
        limit(limitCount)
      );
    }

    const dataSnapshot = await getDocs(q);

    if (dataSnapshot) {
      const data = [];
      dataSnapshot.forEach((doc) => {
        data.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      return data;
    }
    
    return [];
  } catch (error) {
    console.error('Error fetching stocks:', error);
    throw new Error('Failed to fetch stocks data.');
  }
};

export const getStockById = async (stockId) => {
  try {
    if (useApiData) {
      try {
        return await apiGet(`stocks/${stockId}`);
      } catch (error) {
        if (error.status === 404) return null;
        throw error;
      }
    }

    const collectionRef = collection(db, 'stocks');
    const q = query(collectionRef, where('__name__', '==', stockId));
    const dataSnapshot = await getDocs(q);

    if (dataSnapshot && !dataSnapshot.empty) {
      const doc = dataSnapshot.docs[0];
      return {
        id: doc.id,
        ...doc.data(),
      };
    }
    
    return null;
  } catch (error) {
    console.error('Error fetching stock by ID:', error);
    throw new Error('Failed to fetch stock data.');
  }
};
